var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.77778C9.66222 1.77778 11.2244 2.425 12.4 3.6C13.575 4.775 14.2222 6.33778 14.2222 8C14.2222 9.66222 13.575 11.2244 12.4 12.4C11.225 13.575 9.66222 14.2222 8 14.2222C6.33778 14.2222 4.77556 13.575 3.6 12.4C2.425 11.225 1.77778 9.66222 1.77778 8C1.77778 6.33778 2.425 4.77556 3.6 3.6C4.775 2.425 6.33778 1.77778 8 1.77778ZM8 0C3.58167 0 0 3.58167 0 8C0 12.4183 3.58167 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58167 12.4183 0 8 0Z",
    fill: "#DCE4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98166 1.77778C7.98777 1.77778 7.99388 1.77778 7.99999 1.77778C9.66221 1.77778 11.2244 2.425 12.4 3.6C13.575 4.775 14.2222 6.33778 14.2222 8C14.2222 9.66222 13.575 11.2244 12.4 12.4C12.3967 12.4033 12.3939 12.4061 12.3905 12.4089L13.6478 13.6661C15.1011 12.2178 16.0005 10.2139 16.0005 8C16 3.58167 12.4183 0 7.99999 0C7.99388 0 7.98777 0 7.98166 0V1.77778Z",
    fill: "#00725D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadIcon);
export default __webpack_public_path__ + "static/media/LoadIcon.8ff93a8266263d3eb9acdc02631cf93f.svg";
export { ForwardRef as ReactComponent };